import React, { FC, ReactNode } from "react";
import { styled } from "@mui/system";
import { COLORS } from "../../common/consts";

/**
 * A block's heading that opens and closes it: the title with a chevron in
 * front, pointing down when open and right when closed. The block hides its
 * own body; this is only the control.
 */

const Toggle = styled("button")`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 0 -4px;
  padding: 0 4px;
  border: 0;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-align: left;

  &:focus-visible {
    outline: 2px solid var(--color-foregroundBrand, ${COLORS.foregroundBrand});
    outline-offset: 2px;
  }
`;

const Chevron = styled("svg", {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>`
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  color: var(--color-foregroundSecondary, ${COLORS.foregroundSecondary});
  transform: rotate(${({ open }) => (open ? "90deg" : "0deg")});
  transition: transform 0.15s ease;
`;

export const CollapseToggle: FC<{
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}> = ({ open, onToggle, children }) => (
  <Toggle type="button" aria-expanded={open} onClick={onToggle}>
    <Chevron
      open={open}
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 3.5 10.5 8 6 12.5" />
    </Chevron>
    {children}
  </Toggle>
);
